import { useSearchParams } from "react-router-dom";
import { Search } from "@fg/icons";
import { useSearch } from "@/api/hooks";
import { DriveView, PageTitle, type ListQuery } from "./DriveView";
import { EmptyState } from "./EmptyState";

const EMPTY: ListQuery = { data: [], isPending: false, isError: false, error: null, refetch: () => undefined };

/** /search?q=… — every match; folders open, files preview in place. */
export function SearchResultsPage() {
    const [params] = useSearchParams();
    const q = params.get("q")?.trim() ?? "";
    const search = useSearch(q, 100);
    return (
        <DriveView
            variant="search"
            label={q ? `Search results for ${q}` : "Search results"}
            title={<PageTitle icon={Search}>{q ? <>Results for “{q}”</> : "Search"}</PageTitle>}
            query={q ? search : EMPTY}
            resetKey={`search:${q}`}
            emptyState={
                q ? (
                    <EmptyState icon={Search} tone="slate" title="No results" description={`No files or folders match “${q}”.`} />
                ) : (
                    <EmptyState icon={Search} title="Search Drive" description="Type in the search box to find files and folders." />
                )
            }
        />
    );
}
